import type {GcCompensationService} from "./gcCompensationService";
import type {DbExecutor} from "./executor";
import {invalidateHttpReads} from "./httpExecutor";

export const GC_COMMANDS=["gcRead","gcSaveAssociation","gcConfirmEarned","gcBindPortion","gcAttributePayment"] as const;
export function useHostedGcCompensation(service:GcCompensationService,db:Pick<DbExecutor,"whenIdle">,onUnauthorized?:()=>void,request:typeof fetch=fetch){
  const bindings=[["read","gcRead"],["saveAssociation","gcSaveAssociation"],["confirmEarned","gcConfirmEarned"],["bindPortion","gcBindPortion"],["attributePayment","gcAttributePayment"]] as const;
  for(const [method,command] of bindings)Object.defineProperty(service,method,{configurable:true,value:async(...args:unknown[])=>{
    await db.whenIdle?.();
    let response:Response;
    try{response=await request('/api/financial/funding',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({method:command,args})});}
    catch{throw Error('The GC source change could not reach the server. Keep this form open and retry.');}
    if(response.status===401)onUnauthorized?.();
    const payload=await response.json().catch(()=>null) as {result?:unknown;error?:string}|null;
    if(!response.ok||!payload||!('result' in payload))throw Error(payload?.error??'The source association was not confirmed. Reload its source evidence before retrying.');
    if(command!=='gcRead')invalidateHttpReads();
    return payload.result;
  }});
}
